import http from "../http-common";
import User from "../types/User";
import Users from "../types/Users";


const create = (data: User) => {
  return http.post<User>("/create-tenant", data);
};

const update = (id: any, data: User) => {
  return http.put<any>(`/tutorials/${id}`, data);
};

const remove = (id: any) => {
  return http.delete<any>(`/tutorials/${id}`);
};

const removeAll = () => {
  return http.delete<any>(`/tutorials`);
};

const regStandard =(data: Users) =>{
  return http.post<Users>("/register-standard", data);

};

// https://www.wysemanagementsuite.com/reg/register-standard

const standardRenewal =(data: Users) =>{
  return http.post<Users>("/standard_license_Renewal", data);

};

// https://www.wysemanagementsuite.com/reg/standard_license_Renewal


const RegistrationService = {
  create,
  update,
  remove,
  removeAll,
  regStandard,
  standardRenewal
};

export default RegistrationService;